import { isObject, isNullOrUndefined } from "@pineapplelab/util";
import { Paging } from "../paging";
import { FBase } from "./firebase.base";
import { ContractTypeEnum } from "@app/enums/contractType.enum";
import { ContractStatusEnum } from "@app/enums/contract-status.enum";
import { DocumentFile } from "../documentFile";
import { Employee } from "./employee";
import { Clients } from "./clients";
import { ContractFieldType } from "@app/enums/contract-field-type.enum";

export interface IEmailUser  {
  name: string;
  email: string;
}

export interface ContractSignerInfo {
  id: string;
  name: string;
  email: string;
  signerToken: string;
  role?: string;
}

export interface ContractSigner {
  id: string;
  role: string;
  name: string;
  email: string;
  status: ContractStatusEnum;
  signedAt?: any;
  signature?: string;
  signerToken?: string;
  zIndex?: number;
  fieldValues?: { [fieldId: string]: string };
  ip?: string;
  userAgent?: string;
  documentHash?: string;
  files?: string[];
  workflowInstanceId?: string;
  workflowStepId?: string;
}

export interface ContractField {
  id: string;
  type: ContractFieldType;
  page: number;
  x: number;  // Percent
  y: number; // Percent
  width?: number;
  height?: number;
  wPct?: number;
  hPct?: number;
  zIndex?: number;
  label?: string; 
  name?: string;

  key?: string;
  groupKey?: string;
  value?: string;
  optionValue?: string;
  required?: boolean;
  placeholder?: string;
  signerRole?: string;
  options?: string[];
  validation?: {
    minLength?: number;
    maxLength?: number;
    pattern?: string;
    min?: number;
    max?: number;
  };
  conditionalLogic?: {
    dependsOnFieldId: string;
    operator: 'equals' | 'notEquals' | 'includes' | 'startsWith' | 'endsWith';
    value: any;
  };
}

export interface ContractTable {
  id: string;
  name: string;
  fieldIds?: string[];
  columns: {
    id: string;
    name: string;
    fieldIds: string[];
  }[];
}

export class Contract extends FBase {

  name: string = null;
  content: string = null;
  signEnterprise: string = null;
  employeeReceiver: Employee[] = [];
  clientReceiver: Clients[] = [];
  receivers: IEmailUser[] = [{ name: '', email: '' }];
  typeContract: ContractTypeEnum = null;
  files: DocumentFile[] = [];
  pdf: string = null;
  pdfName: string = null;
  message: string = null;
  signedAt: any = null;
  signedBy: string = null;
  status: ContractStatusEnum = ContractStatusEnum.PENDING;
  signature: string = null;
  ip: string = null;
  userAgent: string = null;
  documentHash: string = null;
  fields: ContractField[] = [];
  signers: ContractSigner[] = [];
  tables?: ContractTable[] = [];
  isReutilizable?: boolean;
  senderEmail: string = null;

  __pdf: File;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace Contract {
  export const PATH = 'contracts';

  export const PAGING = new Paging<Contract>(<Paging.IPaging>{
    collection: PATH
  });
}
